import { useFormContext } from 'react-hook-form';

import { VisningsOgDelingsData } from './form/types';

export const useVisningsOgDelingFormContext = () => {
  return useFormContext<VisningsOgDelingsData>();
};
